import { isDevelopment } from '../../variables/is-development';

export const isIframe = () => {
  if (isDevelopment) return true;
  return window.top !== window.self;
};
